// extracted by mini-css-extract-plugin
export default {"divider":"divider-module__divider___x0WhN"};